import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import { Container, GlassCard, PageHero } from "@/components/site/Primitives";
import { loadWhoWeServe } from "@/lib/content-loader";

export const Route = createFileRoute("/industries")({
  loader: () => loadWhoWeServe(),
  head: () => ({
    meta: [
      { title: "Who We Serve — Industries | KS Lau & Co" },
      { name: "description", content: "We serve multinational corporations, large, small and medium enterprises, individuals, family-owned businesses and startups across Malaysia." },
      { property: "og:title", content: "Who We Serve — KS Lau & Co" },
      { property: "og:description", content: "Audiences and industries we support across Malaysia." },
    ],
  }),
  component: IndustriesPage,
});

function IndustriesPage() {
  const industries = Route.useLoaderData();

  return (
    <>
      <PageHero
        title="Trusted across our core audiences."
      />

      <section className="relative pb-24 md:pb-32">
        <Container>
          <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
            {industries.map((i, idx) => (
              <GlassCard key={i.id ?? i.name} animateIndex={idx} className="flex h-full flex-col overflow-hidden p-0">
                <img
                  src={i.image}
                  alt={i.name}
                  loading="lazy"
                  width={1000}
                  height={700}
                  className="aspect-[4/3] w-full object-cover"
                />
                <div className="flex flex-1 flex-col p-6">
                  <p className="text-sm font-bold text-gold">0{idx + 1}</p>
                  <h3 className="mt-2 text-xl font-bold tracking-tight text-primary">{i.name}</h3>
                  <p className="mt-3 text-base leading-relaxed text-muted-foreground">{i.body}</p>
                </div>
              </GlassCard>
            ))}
          </div>

          <div className="mt-16 rounded-md bg-primary p-10 text-primary-foreground md:p-14">
            <div className="grid items-center gap-6 md:grid-cols-[1.5fr_1fr]">
              <div>
                <h3 className="text-2xl font-bold tracking-tight md:text-3xl">
                  Not sure where you fit? Let's start a conversation.
                </h3>
                <p className="mt-3 text-base leading-relaxed text-white/80">
                  Many of our long-standing relationships began with a single conversation about compliance, planning or growth.
                </p>
              </div>
              <Link to="/contact" className="inline-flex items-center justify-center gap-2 rounded-md bg-white px-6 py-3.5 text-base font-semibold text-primary md:justify-self-end">
                Make an enquiry <ArrowRight className="h-4 w-4" />
              </Link>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
}
